import { RefetchOptions } from "@tanstack/react-query";

import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, type IToken, ModuleType, TokenStatus } from "@framework/types";
import ERC721MysteryBoxSimpleUnpackABI from "@framework/abis/json/ERC721MysteryBoxSimple/unpack.json";

export interface IMysteryUnpackButtonProps {
  className?: string;
  disabled?: boolean;
  token: IToken;
  onRefreshPage?: (options?: RefetchOptions) => Promise<void>;
  variant?: ListActionVariant;
}

export const MysteryWrapperUnpackButton = (props: IMysteryUnpackButtonProps) => {
  const {
    className,
    disabled,
    onRefreshPage = () => {
      return;
    },
    token,
    variant = ListActionVariant.button,
  } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFn } = useMetamask(async (token: IToken) => {
    return writeContractAsync({
      address: token.template!.contract!.address as AddressType,
      abi: ERC721MysteryBoxSimpleUnpackABI,
      functionName: "unpack",
      args: [token.tokenId],
    });
  });

  const handleUnpack = (token: IToken): (() => Promise<void>) => {
    return async () => {
      return metaFn(token).then(() => {
        void onRefreshPage();
      });
    };
  };

  if (token.tokenStatus === TokenStatus.BURNED) {
    return null;
  }

  if (token.template?.contract?.contractModule !== ModuleType.MYSTERY) {
    return null;
  }

  return (
    <ListAction
      onClick={handleUnpack(token)}
      message="form.buttons.unpack"
      className={className}
      dataTestId="WrapperUnpackButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
